export default __webpack_public_path__ + "static/media/favicon.70b3322a.png";